import { Sparkles } from 'lucide-react';

// Mentor IA esta em modo "em breve" ate apos o evento. Toda a logica
// (mensagens, prompts, IA) esta preservada no historico do git e pode
// ser reativada removendo este placeholder.
export const MentorPage = () => (
  <section
    className="mx-auto flex w-full max-w-md flex-col items-center justify-center py-16 text-center"
    aria-label="Mentor IA em breve"
  >
    <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-900 text-white shadow-[0_4px_12px_-4px_rgba(16,24,40,0.2)]">
      <Sparkles className="h-7 w-7" />
    </div>

    <span className="mb-3 inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-gray-700">
      Em breve
    </span>

    <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">Mentor IA</h1>

    <p className="mt-3 max-w-sm text-base leading-relaxed text-gray-500">
      Estamos preparando um mentor inteligente pra te ajudar com abordagens, scripts e estratégias
      durante o evento. Disponível em breve.
    </p>
  </section>
);
